// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","365":"cb355538","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"850f319b2c7d101cf974","365":"728b5f211d782313c457","691":"b9bf1effa2cb11531edb"}[chunkId] + ".js";
};